import accordion from './ts/accordion'
import animation from './ts/animation'
import cookie from './ts/cookie'
import currentYear from './ts/current-year'
import lazyLoad from './ts/lazy-load'
import menu from './ts/menu'
import preloader from './ts/preloader'
import scrollHeader from './ts/scroll-header'
import scrollTo from './ts/scroll-to'
import sidebar from './ts/sidebar'
import sliderSwiper from './ts/slider-swiper'
import smoothScroll from './ts/smooth-scroll'
import waved from './ts/waved'

import 'swiper/css/bundle'
import './scss/main.scss'

window.addEventListener('DOMContentLoaded', ((): void => {
  accordion()
  animation()
  cookie()
  currentYear()
  lazyLoad()
  menu()
  scrollHeader()
  scrollTo()
  sidebar()
  sliderSwiper()
  smoothScroll()
  waved()
  preloader()
}) as EventListener)
